import React, {
    PureComponent
  }                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
  }                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import styles                 from './style'
import moment from 'moment';
import DatePicker from 'react-datepicker';

class AddEventTasks extends PureComponent{
    static PropTypes = {
        actions: PropTypes.shape({
            enterPage: PropTypes.func,
            leavePage: PropTypes.func,
        })
    };

    constructor(props){
        super(props);
        this.state = {
            CATEGORIES : [[1, "DESIGN"],[2, "PREPARATION"],[3, "EVENT"],[4,"LEAD PROCESSING"]],
            STATUS : [[31, "STARTED"],[32, "IN PROGRESS"],[33, "BLOCKED"],[34, "DONE"],[35,"NOT STARTED"]],
            subcategories_design : [[101, "TOURNAMENT POSTER"],[102, "MAILER"],[103, "VENUE BRANDING DESIGN"],[104, "WHATSAPP CONTENT"],[105, "REGISTRATION FORM OR LINK"],[105, "BROUCHURE"],[107, "WEB PAGE DESIGN"]],
            subcategories_prep : [[201, "BOOK COURTS"],[202, "VENUE BRANDING"],[203, "JERSEYS"],[204, "TROPHIES"],[205, "SPEAKER AND MIC"],[206, "CHAIR AND TABLE"],[207, "SHAMIANA"],[208, "FOOD AND BERERAGE"],[209, "OUTDOOR BRANDING"]],
            subcategories_event : [[301, "FIXTURE"],[302, "STATUS UPDATE"],[303, "GALLERY"],[304, "OFFICIALS"],[305, "FEEDBACK FORM"]],
            subcategories_lead : [[401, "RESPONSE"],[402, "CALL LATER"],[403, "FEEDBACK FORM"]],
            PRIORITY : [[11, "URGENT"],[12, "HIGH"],[13, "MEDIUM"],[14, "LOW"]],
            venues: [],
            game_types: [],
            event_task_list: [],
            tournament_id:props.match.params.id,
            selected_category:1,
            selected_dueDate:moment(),
            selected_sub_category:101,
            mobile_no:'',
            search:false,
            customer_search_list:[],
            dialog_open_cust:false,
            task_name:'',
            Comment:'',
            details:'',
            priority:11,
            showTaskView:false,

        }
        this.handleChange = this.handleChange.bind(this);
        this.getSearchList = this.getSearchList.bind(this);
        this.handleFile = this.handleFile.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.setSearch = this.setSearch.bind(this);
        this.postEventTask = this.postEventTask.bind(this);
        this.getEventTasks = this.getEventTasks.bind(this);
    }

    componentDidMount() {
        console.log(this.state);
    }

    getEventTasks() {
        const url = `${getLocationOrigin()}/tournament/get_eventTasks/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'tournament_id': this.state.tournament_id
                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({event_task_list : data.result}))
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
    }

    handleOpen(){
        this.setState({dialog_open_cust:true})
    }
    handleClose(){
        this.setState({dialog_open_cust:false})
    }

    postEventTask() {
        console.log('postEventTask')
        if(this.state.task_name == ''){
            alert('please enter task name');
        }
        if(this.state.details == ''){
            alert('please select buddy');
        }
        if(this.state.selected_dueDate == ''){
            alert('Please select DueDate')
        }
        else{
            const url = `${getLocationOrigin()}/tournament/add_event_task/`;
            const options = {...defaultOptions};
            options['method'] = 'post';
            options['headers'] = {'content-type': 'application/json'}
            options['body'] = JSON.stringify({
                                'buddy_id': this.state.details.customer_id,
                                'Duedate': this.state.selected_dueDate,
                                'task_name':this.state.task_name,
                                'comment':this.state.Comment,
                                'category':this.state.selected_category,
                                'sub_category':this.state.selected_sub_category,
                                'priority':this.state.priority,
                                'tournament_id':this.state.tournament_id,
                            });
            return fetch(url, options)
            .then(checkStatus)
            .then(parseJSON)
            .then((response) => {                  
                // alert(response.message);
                //this.setState({loading:false,dialog_open_failed_list:true,failed_list:response.failed_slots})
                // props.history.goBack();
                alert(response.message);
                })
            .catch((error) => {
                console.log(error);
                alert(error.message);
                this.setState({loading:false})
            });
        }
    }
   handleShowtasks(){
    this.getEventTasks();
    this.setState({showTaskView:!this.state.showTaskView});
   }

   getSearchList() {
        var mobile_no = this.state.mobile_no
        const url = `${getLocationOrigin()}/eagleeye/search_buddy/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'search': mobile_no
                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({customer_search_list: data.results, search: true}))
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
    }
    setSearch(name, customer_id, mobile_no){
        var new_selected_one =  Object.assign({}, this.state.details);
        new_selected_one['customer_id'] = customer_id
        new_selected_one['mobile_no'] = mobile_no
        new_selected_one['name'] = name
        this.setState({details: new_selected_one, search: false});
    }

    handleChange(event) {
        const name = event.target.name;
        if (name=='category'){
            this.setState({selected_category:event.target.value,sub_category:(event.target.value * 100 )+ 1})
        }
        if(name == 'sub_category'){
            this.setState({sub_category:event.target.value})
        }
        if(name== 'mobile_no'){
            this.setState({mobile_no:event.target.value})
        }
        if(name=='task_name'){
            this.setState({task_name:event.target.value})
        }
        if(name=='Comment'){
            this.setState({Comment:event.target.value})
        }
        if(name == 'priority'){
            this.setState({priority:event.target.value})
        }
    }

    handleDateChange(new_date){
        
        this.setState({selected_dueDate : new_date});
    }
   
    handleFile(selectorFiles: FileList){
        var new_value =  Object.assign({}, this.state.event_details);
        console.log('Fileeeee');
        console.log(selectorFiles);
        new_value['banner'] = selectorFiles[0]
        this.setState({event_details: new_value});
      }

    
    render(){
        console.log(this.state)

       
        return(
        <div >
            <div  style={{'display':"flex",'flexDirection':"column",'padding':"3%",'marginBottom':"-20px"}}>
                <div className="col-md-12" style={{'backgroundColor':"#84DCF2",'fontSize':"25px",'textAlign':"center"}} onClick={()=> {this.handleShowtasks()}}>
                    EVENT TASKS
                </div>
                {this.state.showTaskView &&
                    <div>
                        <div className="col-md-12" style={{'fontSize':"22px",'textAlign':"center",'marginTop':"10px"}}>
                            <div className="col-md-2">NAME</div>
                            <div className="col-md-2">CATEGORY</div>
                            <div className="col-md-2">SUB CATEGORY</div>
                            <div className="col-md-2">BUDDY</div>
                            <div className="col-md-2">DUEDATE</div>
                            <div className="col-md-2">PRIORITY</div>
                        </div>
                        <div>
                        {this.state.event_task_list.map((task,t) => 
                            <div className="col-md-12" style={{'textAlign':"center"}}>
                                <div className="col-md-2">{task.name}</div>
                                <div className="col-md-2">{task.category}</div>
                                <div className="col-md-2">{task.subcategory}</div>
                                <div className="col-md-2">{task.assigned_to}</div>
                                <div className="col-md-2">{task.due_date}</div>
                                <div className="col-md-2">{task.priority}</div>
                            </div>

                        )}
                        </div>
                    </div>
                }
            </div>
            <div style={styles.container}>
                <div className="row col-md-12 table-bordered" style={styles.table}>
                    <div style={styles.main_header} >
                        <h3 style={{textAlign:'center'}}>Add Tournament Task </h3>
                    </div>
                    <form className="validated-form form-horizontal" onSubmit={this.handleSubmit}>
                    <div className="col-md-12" >
                        <div className="col-md-4" style={{'marginTop':"10px"}}>
                            <div className="col-md-6">
                                Name 
                            </div>
                            <div className="col-md-6">
                                <input type="text" name="task_name" onChange={(e)=>this.handleChange(e)} value={this.state.task_name} /> 
                            </div>
                        </div>
                        <div className="col-md-4" style={{'marginTop':"10px"}} >
                            <div className="col-md-6">
                                Due Date
                            </div>
                            <div className="col-md-6">
                                <DatePicker    selected={this.state.selected_dueDate} onChange={(e) => {this.handleDateChange(e)}} />
                            </div>
                        </div>
                        <div className="col-md-4" style={{'marginTop':"10px"}}>
                            <div className="col-md-6">
                                Comment 
                            </div>
                            <div className="col-md-6">
                                <input type="text" name="Comment" onChange={(e)=>this.handleChange(e)} value={this.state.Comment} /> 
                            </div>
                        </div>
                        <div className="col-md-4" style={{'marginTop':"10px"}}>
                            <div className="col-md-6">
                                CATEGORY
                            </div>
                            <div className="col-md-6">
                                    <select name="category" style={styles.item_body} value={this.state.value}
                                    onChange={this.handleChange}>
                                    {
                                      this.state.CATEGORIES.map((x, index) => (
                                      <option key={x[0]} value={x[0]}>{x[1]}</option>
                                      ))
                                    }
                                  </select>
                            </div>
                        </div>
                        
                        <div className="col-md-4" style={{'marginTop':"10px"}}>
                            <div className="col-md-6">
                                SUB CATEGORY
                            </div>
                            <div className="col-md-6">
                                    <select name="sub_category" style={{'width':"100%"}} value={this.state.value}
                                    onChange={this.handleChange}>
                                    {this.state.selected_category == 1 && 
                                      this.state.subcategories_design.map((x, index) => (
                                      <option key={x[0]} value={x[0]}>{x[1]}</option>
                                      ))
                                    }
                                    {this.state.selected_category == 2 && 
                                      this.state.subcategories_prep.map((x, index) => (
                                      <option key={x[0]} value={x[0]}>{x[1]}</option>
                                      ))
                                    }
                                    {this.state.selected_category == 3 && 
                                      this.state.subcategories_event.map((x, index) => (
                                      <option key={x[0]} value={x[0]}>{x[1]}</option>
                                      ))
                                    }
                                    {this.state.selected_category == 4 && 
                                      this.state.subcategories_lead.map((x, index) => (
                                      <option key={x[0]} value={x[0]}>{x[1]}</option>
                                      ))
                                    }

                                  </select>
                            </div>
                        </div>
                        <div className="col-md-4" style={{'marginTop':"10px"}}>
                            <div className="col-md-6">
                                BUDDY
                            </div>
                            <div className="col-md-6 input-group">
                                    <input type="text" name="mobile_no" className="form-control"
                                    placeholder="Search for.. " value={this.state.mobile_no} onChange={this.handleChange}/>
                                    <span className="input-group-btn">
                                    <button className="btn btn-default glyphicon glyphicon-search"
                                    type="button" onClick={this.getSearchList}></button>
                                    </span>
                             </div>
                        </div>
                        {this.state.search?
                            <div className="col-md-12 btn-group">
                                {this.state.customer_search_list.length?this.state.customer_search_list.map((x) =>(<button key={x.mobile_no+x.name} className="btn btn-default"
                            style={{padding:'1%'}} onClick={() => this.setSearch(x.name,x.id, x.mobile_no)}>{x.name}:{x.mobile_no}</button>))
                            :<div className="alert alert-danger" style={{justifyContent: 'space-between', display: 'flex'}}>
                            <div className="alert alert-danger">Search customer not found</div>
                            <div>
                            <RaisedButton
                            onClick={this.handleOpen}
                            label="Add"
                            style={{float:'right'}}
                            secondary={true}
                            />
                            <Dialog
                            actions={actions}
                            modal={false}
                            open={this.state.dialog_open_cust}
                            onRequestClose={this.handleClose}
                            >
                            <div>
                                <div style={styles.main_header} className="col-md-12">
                                <h3 style={{textAlign:'center'}}>Add New Customer</h3>
                                </div>
                                <div style={styles.items} className="col-md-12">
                                <div style={styles.item_header} className="col-md-6">
                                    Name
                                </div>
                                <input type="text" style={styles.input} name="cust_name" className="required"
                                    value={this.state.value} onChange={this.handleChange}/>
                                </div>

                                <div style={styles.items} className="col-md-12">
                                <div style={styles.item_header} className="col-md-6">
                                    Mobile No
                                </div>
                                <input type="number" style={styles.input} name="cust_mobile_no" className="required"
                                    value={this.state.mobile_no} onChange={this.handleChange}/>
                                </div>
                            </div>
                            </Dialog>
                        </div>
                        </div>
                    }</div>:''}
                        <div className="col-md-4" style={{'marginTop':"10px"}}>
                            <div className="col-md-6">
                                PRIORITY 
                            </div>
                            <div className="col-md-6">
                                    <select name="priority" style={styles.item_body} value={this.state.value}
                                    onChange={(e)=>this.handleChange(e)}>
                                    {
                                      this.state.PRIORITY.map((x, index) => (
                                      <option key={x[0]} value={x[0]}>{x[1]}</option>
                                      ))
                                    }
                                  </select>
                            </div>
                        </div>
                        
                    </div>
                    <div className="col-md-12" style={{textAlign:"center"}} >
                        <input type="button" style={{backgroundColor: '#32B6A7',width:"20%"}} onClick={this.postEventTask} value="Add task" />
                    </div>
                    </form>
                </div>
            </div>  
        </div>  
        );
    }
}

export default AddEventTasks;


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addTournamentTasks/index.js